import { render, staticRenderFns } from "./importOwnerCar.vue?vue&type=template&id=03268871&scoped=true"
import script from "./importOwnerCar.vue?vue&type=script&lang=js"
export * from "./importOwnerCar.vue?vue&type=script&lang=js"
import style0 from "./importOwnerCar.vue?vue&type=style&index=0&id=03268871&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03268871",
  null
  
)

export default component.exports